import { useYear } from "@/contexts/YearContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Calendar } from "lucide-react";

export default function YearSelector({ className = "" }) {
  const { selectedYear, setSelectedYear, years } = useYear();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Calendar className="w-4 h-4 text-white/70" />
      <Select 
        value={selectedYear.toString()} 
        onValueChange={(value) => setSelectedYear(parseInt(value))}
      >
        <SelectTrigger className="w-24 h-8 bg-white/10 border-white/20 text-white text-sm hover:bg-white/20">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-60">
          {years.map((year) => (
            <SelectItem key={year} value={year.toString()}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
